export const ExperienceData = [
  {
    title: 'Tashkent International School',
    date: 'Jul 2011 - May 2014',
    details: [
      "Graduated Tashkent International School, Uzbekistan",
      "Achieved Diploma programme under IB curriculum"
    ],
  },
  {
    title: 'Ghent University',
    date: 'Sep 2014 - Jun 2016',
    details: [
      'Studied Bioinformatics in Ghent University',
    ],
  },
  {
    title: 'Military Service in South Korea',
    date: 'Sep 5 2016 - Jun 4 2018',
    details: [
      'serve as a drill-instructor in Republic of Korea Army'
    ],
  },
  {
    title: 'State University of NewYork in Korea',
    date: 'Aug 2018 - June 2021',
    details: [
      'Major in Computer Science',
    ],
  },
  {
    title: 'SW developer in Seegene',
    date: 'Jul 2021 - Present',
    details: [
      'DNA Sequence Analysis Service Development (Scrum Master)',
      'Improving DNA Binding Image Generation Service (Scrum Member)',
      'Pipeline Development and Automation for Large-Scale Genomic Databases (Scrum Member)',
      'Redevelopment of PCR Sequence Combination Service (Scrum Member)'
    ],
  }
];
